<div class="tool-bar">
  <div class="add-group-button-group" *ngIf="!loadingSpinner">
    <button class="add-group-button" mat-button (click)="addGroup()">New Group</button>
  </div>
</div>
<div class="item-groups">
  <ng-container *ngIf="!loadingSpinner">
    <div class="group-type" *ngFor="let itemGroup of itemGroups let i = index">
      <div class="group-type-title">
        <div class="buttons-block" *ngIf="!loadingSpinner">
          <button class="item-button add-item-button" mat-button (click)="addNewItem(i, itemEditorTable)">New Item
          </button>
          <button class="item-button delete-item-button" mat-button (click)="deleteGroup(i)">Delete Group</button>
        </div>

        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="itemGroup.name" (ngModelChange)="changesMade(i)">
      </div>
      <div class="group-type-body">
        <p-table #itemEditorTable [value]="itemGroup.items" (onEditInit)="startEdit()"
                 (onEditComplete)="onEditComplete($event, i)" class="item-editor-table">
          <ng-template pTemplate="header">
            <tr>
              <th class="name-cell">Name</th>
              <th>Price</th>
              <th>Ins. Price</th>
              <th>Description
              <th>Files</th>
              <th class="delete-cell"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <td pEditableColumn class="editable-cell name-cell">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.name">
                  </ng-template>
                  <ng-template pTemplate="output">
                    <!-- {{roundNum(rowData.price)}} -->
                    {{rowData.name}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn class="editable-cell price-cell">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.pricePerItem">
                  </ng-template>
                  <ng-template pTemplate="output">
                    <!-- {{roundNum(rowData.price)}} -->
                    ${{rowData.pricePerItem}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn class="editable-cell price-cell">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                           [(ngModel)]="rowData.pricePerItemInstall">
                  </ng-template>
                  <ng-template pTemplate="output">
                    <!-- {{roundNum(rowData.price)}} -->
                    ${{rowData.pricePerItemInstall}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td pEditableColumn class="editable-cell description-cell">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText BlockLateralArrowNavigation type="text" class="material-input-text"
                           [(ngModel)]="rowData.description">
                  </ng-template>
                  <ng-template pTemplate="output">
                    <!-- {{roundNum(rowData.price)}} -->
                    {{rowData.description}}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="file-cell not-editable-cell" (click)="openFiles(i, rowIndex)"
                  [ngClass]="{'has-files': rowData.hasFiles}">
                <i class="pi pi-paperclip" style="font-size: 100%"></i>
              </td>
              <td class="delete-cell not-editable-cell" (click)="deleteLine(i, rowIndex)">
                <i class="pi pi-trash" style="font-size: 100%"></i>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-container>

</div>

<div class="loading-body" *ngIf="loadingSpinner">
  <lib-progress-spinner></lib-progress-spinner>
</div>


<p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="item-panel">
</p-confirmDialog>
